export default __webpack_public_path__ + "static/media/DanHoang_Resume.b6c196a7.pdf";